import { ofType } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/internal-compatibility';
import { of, forkJoin } from 'rxjs';
import {
  GET_COMPANY_METADATA_ERROR,
  GET_COMPANY_STATUS,
  GET_COMPANY_STATUS_ERROR,
  SET_COMPANY_STATUS,
} from '@actions/company';
import { get_isCarrierOndDeck } from '@api/directOffers';
import { get } from 'lodash';

export const getCompanyStatus = action$ =>
  action$.pipe(
    ofType(GET_COMPANY_STATUS),
    switchMap(action => {
      const { apiUrl, companyKey, authenticationToken } = action.payload;
      return fromPromise(
        get_isCarrierOndDeck(apiUrl, companyKey, authenticationToken),
      ).pipe(
        map(carrier_response => {
          const payload = {
            is_on_deck: get(carrier_response, ['data', 'is_on_deck'], ''),
          };
          return { type: SET_COMPANY_STATUS, payload };
        }),
        catchError(err => {
          var status = get(err, ['response', 'status'], '');
          if (status) {
            return of({
              type: GET_COMPANY_STATUS_ERROR,
              payload: { status },
            });
          } else {
            return of({
              type: GET_COMPANY_STATUS_ERROR,
              payload: { is_on_deck: false },
            });
          }
        }),
      );
    }),
  );
